import React from 'react';
import { Typography } from 'antd';
import { mediaUrl } from '../utils/media';

const { Text } = Typography;

interface StagePhotosProps {
  attachments?: any[];
}

// Photos grouped by stage (the attachment caption), each with its upload time.
const StagePhotos: React.FC<StagePhotosProps> = ({ attachments }) => {
  const groups: Record<string, any[]> = {};
  (attachments || []).forEach((att) => {
    const stage = att.caption || 'Photos';
    (groups[stage] = groups[stage] || []).push(att);
  });

  const stages = Object.keys(groups);
  if (stages.length === 0) return <Text type="secondary">No photos yet.</Text>;

  return (
    <>
      {stages.map((stage) => (
        <div key={stage} style={{ marginBottom: 16 }}>
          <Text strong>{stage}</Text>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6 }}>
            {groups[stage].map((att) => (
              <div key={att.id} style={{ width: 96 }}>
                <a href={mediaUrl(att.file)} target="_blank" rel="noopener noreferrer">
                  <img
                    src={mediaUrl(att.file)}
                    alt={stage}
                    style={{ width: 96, height: 96, objectFit: 'cover', borderRadius: 6 }}
                  />
                </a>
                <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                  {new Date(att.uploaded_at).toLocaleString('en-IN')}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default StagePhotos;
